import React from "react";
import styled from "styled-components";
import { FlexBox } from "js/react/components/LayoutGrid";
import { CloseRounded, InfoRounded } from "@mui/icons-material";
import { IconButton } from "js/Components/IconButton";

interface BannerContainerProps {
    headerText?: string;
    bodyText?: string;
    borderColor?: string;
    icon?: React.ReactNode;
    onClose?: () => void;
}

const BannerContainer = styled.div<{ borderColor?: string }>`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    align-self: stretch;
    justify-content: space-between;
    padding: 16px;
    border-radius: 4px;
    gap: 5px;
    user-select: none;
    border: 1px solid ${({ borderColor }) => borderColor || "#11A9E2"};
    position: relative;
`;

const BannerHeader = styled.div`
    color: #333;
    font-family: "Source Sans Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
`;

const BannerBody = styled.div`
    font-family: "Lato";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    flex: 1;
    min-width: 0;
    padding-right: 20px;
`;

const StyledIconButton = styled(IconButton)`
    position: absolute;
    right: 2px;
    top: 2px;
    flex-shrink: 0;
`;

export default function InfoBanner({ headerText, bodyText, borderColor, onClose = () => {}, icon = <InfoRounded style={{ color: "#11A9E2" }} /> }: BannerContainerProps) {
    return (
        <BannerContainer borderColor={borderColor}>
            <TextContainer>
                { icon }
                <FlexBox column left>
                    <BannerHeader>{headerText}</BannerHeader>
                    <BannerBody>{bodyText}</BannerBody>
                </FlexBox>
            </TextContainer>
            <StyledIconButton icon={<CloseRounded />} onClick={onClose} />
        </BannerContainer>
    );
}
